import { CategoryPage } from "./CategoryPage";
import { DashboardPage } from "./DashboardPage";
import { EmailTemplatesPage } from "./EmailTemplatesPage";
import { ExamPeriodPage } from "./exam-periods/ExamPeriodPage";
import { ExamPeriodCorrectionPage } from "./exam-periods/ExamPeriodCorrectionPage";
import { NewExamPeriodPage } from "./exam-periods/NewExamPeriodPage";
import { ExamsPage } from "./exams/ExamsPage";
import { NewExamPage } from "./exams/NewExamPage";
import { ExamPeriodMonitoringPage } from "./exam-periods/ExamPeriodMonitoringPage";
import { ReportsPage } from "./ReportsPage";
import { LevelDReportsPage } from "./LevelDReportsPage";
import { LevelCReportsPage } from "./LevelCReportsPage";
import { LevelBReportsPage } from "./LevelBReportsPage";
import { ReportsHubPage } from "./reports/ReportsHubPage";
import { QuizStatisticsPage } from "./reports/QuizStatisticsPage";
import { TournamentReportsPage } from "./reports/TournamentReportsPage";
import { UsersPage } from "./UserPage";
import { PendingCorrectionsPage } from "./grading/PendingCorrectionsPage";
import { lazy } from "react";
const BankPoolPage = lazy(() => import("../pages/bank-pool/BankPoolPage"));
const ErrorPage = lazy(() => import("./ErrorPage"));


export {
    CategoryPage,
    DashboardPage,
    EmailTemplatesPage,
    BankPoolPage,
    ExamPeriodCorrectionPage,
    ExamPeriodPage,
    NewExamPeriodPage,
    ExamsPage,
    NewExamPage,
    ExamPeriodMonitoringPage,
    UsersPage,
    PendingCorrectionsPage,
    ErrorPage,
    ReportsPage,
    LevelDReportsPage,
    LevelCReportsPage,
    LevelBReportsPage,
    ReportsHubPage,
    QuizStatisticsPage,
    TournamentReportsPage
}